import { ICellRendererParams } from "@ag-grid-community/core";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useIsFormDisabled } from "shared/components/form/FormStateProvider";
import { SimpleMoneyInput } from "shared/components/input/text/SimpleMoneyInput";
import { getMaybernTableCellError } from "shared/components/table/maybern/MaybernTableErrors";
import { MaybernTableFocusCellRendererWrapper } from "shared/components/table/maybern/MaybernTableFocusCellRendererWrapper";

export const MaybernTableCellRenderer: React.FC<ICellRendererParams> = (
  params,
) => {
  const { t } = useTranslation(["common"]);
  const ref = useRef<never>(null);
  const isFormDisabled = useIsFormDisabled();
  return (
    <MaybernTableFocusCellRendererWrapper params={params} inputRef={ref}>
      <SimpleMoneyInput
        ref={ref}
        variant="simple-table"
        placeholder={t("common:enterAmount")}
        value={params.value}
        onChangeValue={params.setValue}
        showCurrencyIcon={false}
        showCurrencyPrefix={false}
        allowNegative={true}
        error={getMaybernTableCellError(params)}
        isDisabled={isFormDisabled}
      />
    </MaybernTableFocusCellRendererWrapper>
  );
};
